import React, { useState } from 'react';
import { updateProfile, updateProfilePassword } from '../../utils/accountsApi';
import './Profile.css';
import Footer from '../Footer';

function Profile({ username, firstName, lastName, role, setFirstName, setLastName }) {
  const [firstNameInput, setFirstNameInput] = useState(firstName || '');
  const [lastNameInput, setLastNameInput] = useState(lastName || '');
  const [savingName, setSavingName] = useState(false);
  const [nameError, setNameError] = useState('');
  const [nameSaved, setNameSaved] = useState(false);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [savingPassword, setSavingPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSaved, setPasswordSaved] = useState(false);

  const handleSaveName = async () => {
    const trimmedFirst = firstNameInput.trim();
    const trimmedLast = lastNameInput.trim();
    if (!trimmedFirst || !trimmedLast) { setNameError('First and last name are required.'); return; }
    setSavingName(true);
    setNameError('');
    setNameSaved(false);
    try {
      await updateProfile(username, { firstName: trimmedFirst, lastName: trimmedLast });
      localStorage.setItem('firstName', trimmedFirst);
      localStorage.setItem('lastName', trimmedLast);
      setFirstName(trimmedFirst);
      setLastName(trimmedLast);
      setNameSaved(true);
    } catch (err) {
      setNameError(err.response?.data?.error || 'Could not save your name. Please try again.');
    } finally {
      setSavingName(false);
    }
  };

  const handleSavePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError('All password fields are required.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError('New passwords do not match.');
      return;
    }
    setSavingPassword(true);
    setPasswordError('');
    setPasswordSaved(false);
    try {
      await updateProfilePassword(username, currentPassword, newPassword);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setPasswordSaved(true);
    } catch (err) {
      setPasswordError(err.response?.data?.error || 'Could not update your password. Please try again.');
    } finally {
      setSavingPassword(false);
    }
  };

  return (
    <div className="root-container">
      <div className="title-container">
        <div className="title-left">
          <div className="title-name-container">
            <header className="name-header">My Profile</header>
          </div>
        </div>
      </div>

      <div className="component-container">
        <div className="profile-content">

          <div className="profile-card">
            <h2 className="profile-card-title">Name</h2>
            <div className="teacher-create-fields">
              <input
                className="review-name-input"
                value={firstNameInput}
                onChange={(e) => { setFirstNameInput(e.target.value); setNameSaved(false); }}
                placeholder="First name"
                disabled={savingName}
              />
              <input
                className="review-name-input"
                value={lastNameInput}
                onChange={(e) => { setLastNameInput(e.target.value); setNameSaved(false); }}
                placeholder="Last name"
                disabled={savingName}
              />
              <button className="title-button" onClick={handleSaveName} disabled={savingName}>
                {savingName ? 'Saving...' : 'Save'}
              </button>
            </div>
            {nameError && <span className="review-field-error">{nameError}</span>}
            {nameSaved && !nameError && <span className="profile-saved-note">Saved.</span>}
          </div>

          <div className="profile-card">
            <h2 className="profile-card-title">Email</h2>
            <input className="review-name-input review-field-readonly" value={username} disabled readOnly />
            <span className="profile-hint">Your email can't be changed once your account is created.</span>
          </div>

          <div className="profile-card profile-card-inline">
            <h2 className="profile-card-title">Account Type</h2>
            <span className="class-detail-count profile-account-type-badge">{role ? role.charAt(0).toUpperCase() + role.slice(1) : '—'}</span>
          </div>

          <div className="profile-card">
            <h2 className="profile-card-title">Password</h2>
            <div className="profile-password-fields">
              <input
                type="password"
                className="review-name-input"
                value={currentPassword}
                onChange={(e) => { setCurrentPassword(e.target.value); setPasswordSaved(false); }}
                placeholder="Current password"
                disabled={savingPassword}
              />
              <input
                type="password"
                className="review-name-input"
                value={newPassword}
                onChange={(e) => { setNewPassword(e.target.value); setPasswordSaved(false); }}
                placeholder="New password"
                disabled={savingPassword}
              />
              <input
                type="password"
                className="review-name-input"
                value={confirmPassword}
                onChange={(e) => { setConfirmPassword(e.target.value); setPasswordSaved(false); }}
                placeholder="Confirm new password"
                disabled={savingPassword}
                onKeyDown={(e) => { if (e.key === 'Enter') handleSavePassword(); }}
              />
              <button className="title-button profile-password-submit" onClick={handleSavePassword} disabled={savingPassword}>
                {savingPassword ? 'Updating...' : 'Update Password'}
              </button>
            </div>
            {passwordError && <span className="review-field-error">{passwordError}</span>}
            {passwordSaved && !passwordError && <span className="profile-saved-note">Password updated.</span>}
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Profile;
